import { generateSlug } from "@/helpers/generateSlug";
import { BlogPost } from "./blogPosts";
import { Expertise } from "./expertiseData";
import { ExpertiseEnum } from "./expertiseEnum";
import { ExpertiseCityStringSet } from "./strings/expertiseCityStrings";
import { TeamMember } from "./teamData";

export const brevoDemoUrl = "https://meet.brevo.com/solving-legal-erstberatung";

export const expertiseSlugs: Record<ExpertiseEnum, string> = {
  [ExpertiseEnum.Arbeitsrecht]: generateSlug("arbeitsrecht"),
  [ExpertiseEnum.Erbrecht]: generateSlug("erbrecht-und-unternehmensnachfolge"),
  [ExpertiseEnum.Gesellschaftsrecht]: generateSlug(
    "gesellschaftsrecht-und-aktienrecht",
  ),
  [ExpertiseEnum.Startuprecht]: generateSlug("startuprecht"),
  [ExpertiseEnum.Steuerrecht]: generateSlug("steuerrecht-und-bilanzrecht"),
  [ExpertiseEnum.Prozessfuehrung]: generateSlug(
    "prozessfuehrung-und-streitbeilegung",
  ),
  [ExpertiseEnum.InternetMedienRecht]: generateSlug("internet-und-medienrecht"),
  [ExpertiseEnum.Insolvenzrecht]: generateSlug("insolvenzrecht"),
};
const landingpageSlug = "l";
const aboutSlug = "about";
const expertisePreSlug = "expertise";
const blogSlug = "blog";

export const solvingTaxSlug = "solving-tax";

export const slRoutes = {
  teamMember: (slug: TeamMember["slug"]) => `/${aboutSlug}/${slug}`,
  solvingTax: `/${aboutSlug}/${solvingTaxSlug}`,
  expertiseField: (slug: Expertise["slug"]) => `/${expertisePreSlug}/${slug}`,
  expertiseCity: (
    expertiseSlug: Expertise["slug"],
    citySlug: ExpertiseCityStringSet["slug"],
  ) => `/${expertisePreSlug}/${expertiseSlug}/${citySlug}`,
  expertiseCitySection: (
    expertiseSlug: Expertise["slug"],
    citySlug: ExpertiseCityStringSet["slug"],
    sectionId: string,
  ) => `/${expertisePreSlug}/${expertiseSlug}/${citySlug}#${sectionId}`,
  expertiseCityStatisticsArchive: (
    expertiseSlug: Expertise["slug"],
    citySlug: ExpertiseCityStringSet["slug"],
    year: number,
  ) => `/${expertisePreSlug}/${expertiseSlug}/${citySlug}/statistik/${year}`,
  /** CSV download for Dataset schema distribution (e.g. /downloads/statistik/koblenz/2025) */
  statisticsCsvDownload: (citySlug: string, year: number) =>
    `/downloads/statistik/${citySlug}/${year}`,
  blog: `/${blogSlug}`,
  blogPost: (slug: BlogPost["slug"]) => `/${blogSlug}/${slug}`,

  landingpages: {
    arbeitsrecht: {
      abfindungAutoindustrie: `/${landingpageSlug}/${expertiseSlugs[ExpertiseEnum.Arbeitsrecht]}/abfindung-autoindustrie`,
      abfindungsrechner: `/${landingpageSlug}/${expertiseSlugs[ExpertiseEnum.Arbeitsrecht]}/abfindungsrechner`,
    },
    gesellschaftsrecht: {
      holdingstrukturen: `/${landingpageSlug}/${expertiseSlugs[ExpertiseEnum.Gesellschaftsrecht]}/holdingstrukturen`,
    },
  },
  imprint: "/imprint",
  privacy: "/privacy",
  calculator: {
    pflichtteilrechner: `/${expertiseSlugs[ExpertiseEnum.Erbrecht]}/pflichtteil-rechner`,
    grundungskostenrechner: `/${expertiseSlugs[ExpertiseEnum.Startuprecht]}/grundungskosten-rechner`,
  },
};
